import type * as React from 'react';

function SvgBetslip(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M20 2H4C2.8975 2 2 2.897 2 4V20C2 21.103 2.8975 22 4 22H5.1289C5.6631 22 6.165 21.792 6.543 21.4141L8.3291 19.6285L10.1143 21.4146C10.4922 21.792 10.9952 22 11.5293 22H12.2988C12.8349 22 13.3379 21.7915 13.7148 21.4136L15.5 19.6284L17.2832 21.4116C17.6621 21.791 18.167 22 18.7031 22H20C21.1025 22 22 21.103 22 20V4C22 2.897 21.1025 2 20 2ZM20 20L18.6973 19.9976L15.5 16.8003L12.2988 20L11.5273 19.9995L8.3291 16.8003L5.1289 20H4V4H20V20Z"
        fill="currentColor"
      />
      <path
        d="M7 8.75H17C17.4141 8.75 17.75 8.4141 17.75 8C17.75 7.5859 17.4141 7.25 17 7.25H7C6.5859 7.25 6.25 7.5859 6.25 8C6.25 8.4141 6.5859 8.75 7 8.75Z"
        fill="currentColor"
      />
      <path
        d="M7 13.75H13C13.4141 13.75 13.75 13.4141 13.75 13C13.75 12.5859 13.4141 12.25 13 12.25H7C6.5859 12.25 6.25 12.5859 6.25 13C6.25 13.4141 6.5859 13.75 7 13.75Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgBetslip;
